export default __webpack_public_path__ + "static/media/1 a.4f54c0ae.png";